export const finds = [
  {
    id: 1,
    name: 'Nike Air Jordan 4 Retro',
    category: 'Buty',
    rating: '9.5/10',
  },
  {
    id: 2,
    name: 'Balenciaga Hoodie Oversized',
    category: 'Bluzy / Swetry',
    rating: '9.2/10',
  },
  {
    id: 3,
    name: 'Vintage Carhartt Jacket',
    category: 'Kurtki',
    rating: '8.9/10',
  },
  {
    id: 4,
    name: 'Supreme Box Logo Tee',
    category: 'T-Shirty',
    rating: '9.0/10',
  },
  {
    id: 5,
    name: 'New Era 59FIFTY Fitted Cap',
    category: 'Nakrycia głowy',
    rating: '8.7/10',
  },
  {
    id: 6,
    name: 'Essentials Fear of God Set',
    category: 'Zestawy',
    rating: '9.3/10',
  },
];